import './sections.scss';
import SimpleSlider from './Slider';

function SectionItem(props) {
    let subtitle = props.sectionInfo[0].h1;
    let SectionList = props.sectionInfo.map ((cart, idx) =>
    {    
        return ( 
            <div className={"section " + (cart.className)} key={idx}>
                <div className="section_desc">
                    <div className="title-desc">
                        <div className="subtitle-desc">
                            {subtitle}
                        </div>
                        <div className="title">
                            {cart.title}
                        </div>
                        <div className="text">
                            {cart.text}
                        </div>
                    </div>
                    <div className="wrap-price">
                        <div className="wrap-price-color">
                            <div className="price">
                                <div className="price-new">
                                {cart.priceNew}
                                </div>
                            </div>
                        </div>
                        
                        <div className="wrap-price-btn">
                            <div className="btn-buy">
                                <a className="link-buy" href = {cart.href}>
                                    Купить
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M7.49996 18.3337C7.9602 18.3337 8.33329 17.9606 8.33329 17.5003C8.33329 17.0401 7.9602 16.667 7.49996 16.667C7.03972 16.667 6.66663 17.0401 6.66663 17.5003C6.66663 17.9606 7.03972 18.3337 7.49996 18.3337Z" stroke="#040404" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M16.6667 18.3337C17.1269 18.3337 17.5 17.9606 17.5 17.5003C17.5 17.0401 17.1269 16.667 16.6667 16.667C16.2065 16.667 15.8334 17.0401 15.8334 17.5003C15.8334 17.9606 16.2065 18.3337 16.6667 18.3337Z" stroke="#040404" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M0.833374 0.833008H4.16671L6.40004 11.9913C6.47624 12.375 6.68496 12.7196 6.98966 12.9649C7.29436 13.2102 7.67562 13.3405 8.06671 13.333H16.1667C16.5578 13.3405 16.9391 13.2102 17.2438 12.9649C17.5484 12.7196 17.7572 12.375 17.8334 11.9913L19.1667 4.99967H5.00004" stroke="#040404" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="section_pic-slider">
                    <img loading="lazy" alt ="" className = "pic_EISA" src = {cart.EISA}/>
                    <SimpleSlider data = {cart}/>
                </div>
            </div>
        )
    });

return (
    <div>{SectionList}</div>
)}
export default SectionItem;